export default class AbstractModule {
  static id;

  static dependencies = [];

  // eslint-disable-next-line no-unused-vars
  constructor(context) {}
}
